import React from 'react';
import styled from 'styled-components';

import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Typography } from '@mui/material';

import Radio from '@ui-elements/Radio';
import Collapse from '@mui/material/Collapse';

import { useTranslation } from 'react-i18next';
import { FONT_SIZES, PALETTE } from '~/assets/styles/base';

import { SURVEY_STATUSES } from '~/constants';

const Wrapper = styled.div`
  margin: 0 auto;
`;

const RadioBox = styled.div`
  width: 100%;
  margin: 10px 0;
  padding: 15px 20px;
  border: solid ${PALETTE.border.frame} 1px;
  border-radius: 15px;
  background: ${PALETTE.white};
`;

const InputArea = styled.div`
  margin: 10px 0;
`;

const StyledTypography = styled(Typography)`
  font-size: ${FONT_SIZES.modalInputDefault};
  margin-left: 18px;
`;

type Props = {
  children?: React.ReactNode;
  value: string | number | null;
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleRadioChange: Function;
  error?: boolean;
};

const StatusArea: React.FC<Props> = ({
  children,
  value,
  handleRadioChange,
  error = false,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <FormControl component="fieldset" error={error} fullWidth>
        <RadioGroup
          aria-label="status-radio"
          name="status-radio"
          value={value}
          onChange={(e) => {
            handleRadioChange(e);
          }}
          data-testid="StatusArea"
        >
          <RadioBox>
            <FormControlLabel
              value={SURVEY_STATUSES.REJECTED}
              control={
                <Radio
                  color="primary"
                  data-testid="StatusAreaRadioReject"
                  value={SURVEY_STATUSES.REJECTED}
                  checked={Number(value) === SURVEY_STATUSES.REJECTED}
                />
              }
              label={<StyledTypography>{t('changeSurveyStatus.reject')}</StyledTypography>}
            />
            <Collapse in={Number(value) === SURVEY_STATUSES.REJECTED} timeout="auto" unmountOnExit>
              <InputArea data-testid="StatusArea-Input-1">{children}</InputArea>
            </Collapse>
          </RadioBox>
          <RadioBox>
            <FormControlLabel
              value={SURVEY_STATUSES.APPROVED}
              control={
                <Radio
                  color="primary"
                  data-testid="StatusAreaRadioApprove"
                  value={SURVEY_STATUSES.APPROVED}
                  checked={Number(value) === SURVEY_STATUSES.APPROVED}
                />
              }
              label={<StyledTypography>{t('changeSurveyStatus.approve')}</StyledTypography>}
            />
          </RadioBox>
        </RadioGroup>
      </FormControl>
    </Wrapper>
  );
};

export default StatusArea;
